import React, { useEffect } from 'react';
import { getCityFromPath } from "../app/auth";

const UnknownUrl: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white p-4">
      <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-lg w-full text-center">
        <h1 className="text-3xl font-bold mb-4">Fehler</h1>
        <p className="mb-4">Links aus dem alten Ratsinformationssystem werden nicht mehr unterstützt.</p>
      </div>

      <a className="mt-5 underline hover:text-blue-400" href="/">Zurück zum Dashboard</a>

    </div>
  );
};

export default UnknownUrl;
